export function getCurrentApiUrl() {
  switch (process.env.REACT_APP_ENV) {
    case 'dev':
      return process.env.REACT_APP_API_URL_CONSOLE_DEV;

    case 'stg':
      return process.env.REACT_APP_API_URL_CONSOLE_STG;

    case 'prod':
      return process.env.REACT_APP_API_URL_CONSOLE_PROD;

    default:
      return process.env.REACT_APP_API_URL_CONSOLE;
  }
}

export function getCurrentUrl() {
  switch (process.env.REACT_APP_ENV) {
    case 'dev':
      return process.env.REACT_APP_URL_CONSOLE_DEV;

    case 'stg':
      return process.env.REACT_APP_URL_CONSOLE_STG;

    case 'prod':
      return process.env.REACT_APP_URL_CONSOLE_PROD;

    default:
      return process.env.REACT_APP_URL_CONSOLE_DEV;
  }
}

export const tryRequire = path => {
  try {
    return require(`${path}`);
  } catch (err) {
    return null;
  }
};
